// extracted by mini-css-extract-plugin
export default {"myBtn":"Buttons_myBtn__AjSyv"};